import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import {
  Row,
  Typography,
  Card,
  Spin,
  Form,
  Button,
  Divider,
  Col,
  Collapse,
  Dropdown,
} from "antd";

//ANT DESIGN ICONS IMPORTS
import {
  SettingOutlined,
  LeftOutlined,
  UploadOutlined,
  CalculatorOutlined,
  HolderOutlined,
  DoubleRightOutlined,
} from "@ant-design/icons";

//PROJECT IMPORTS
import TopContent from "../../../../../components/layouts/TopContent";
import { BOM } from "../../../../../services/definedMethod";
import cnt from "../../../../../services/definedConstant";
import "../../../../../assets/styles/DatePicker.css";
import MainLayout from "../../../../../components/layouts/MainLayout";
import { apiConfig, labelConfig, staticConfig } from "../../../group.config";
import Transactions from "./tabs/transactions/Transactions";
import Memo from "./tabs/Memo";
import Charges from "./tabs/Charges";
import { rightAction } from "../../../../../redux/actions";
import {
  handleFlgStatus,
  AmountFormat,
  AccountFacility,
} from "../../../../../components/facilities/AccountFacility";
import {
  accountStatus,
  handleGroupSavingsDetailActionButtons,
} from "../../../../../components/facilities/GroupFacility";

const { Text, Title } = Typography;
const { Panel } = Collapse;

const DetailGroupSavings = (props) => {
  //DECLARED VARIABLES
  const { userData, rightAction } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const { state } = useLocation();
  const [useForm] = Form.useForm();
  const [accountDetails, setAccountDetails] = useState([]);
  const [chargesList, setChargesList] = useState([]);
  const [memoList, setMemoList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [transactionsList, setTransactionsList] = useState([]);

  const [activeTabKey, setActiveTabKey] = useState("transactions");
  const [menuProps, setMenuProps] = useState({
    items: [],
  });
  const tabList = [
    {
      key: "transactions",
      label: "Transactions",
      disabled: !BOM.HasPermission("READ_SAVINGSACCOUNT"),
    },
    {
      key: "charges",
      label: "Charges",
      disabled: !BOM.HasPermission("READ_SAVINGSACCOUNTCHARGE"),
    },
    {
      key: "memo",
      label: "Notes",
      disabled: !BOM.HasPermission("READ_SAVINGNOTE"),
    },
  ];

  useEffect(() => {
    getDetailById();
    BOM.HasPermission("READ_SAVINGNOTE") && getNotes();
  }, []);

  const getDetailById = () => {
    const params = {
      associations: "all",
    };
    const url = `${apiConfig.SavingsAccounts}/${state.id}`;

    let body = {
      session,
      params,
    };
    setIsLoading(true);

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setAccountDetails(objDetail);

        let tempInterestRateChartArray = [];
        let tempChargesArray = [];
        let tempTransactionsArray = [];

        objDetail?.accountChart?.chartSlabs?.forEach((element) => {
          tempInterestRateChartArray.push({
            key: element?.id,
            id: element?.id,
            periodType: element?.periodType ? element?.periodType?.value : "-",
            periodFromTo: `${element?.fromPeriod} - ${element?.toPeriod}`,
            amountRange: element?.amountRangeFrom
              ? element?.amountRangeFrom
              : "-",
            interest: element?.annualInterestRate
              ? element?.annualInterestRate
              : "-",
          });
        });

        objDetail?.transactions?.forEach((element) => {
          tempTransactionsArray.push({
            key: element?.id,
            id: element?.id,
            transactionDate: element?.date
              ? BOM.DateTime(element?.date, "only-date")
              : "-",
            transactionType: element?.transactionType
              ? element?.transactionType?.value
              : "-",
            debit: element?.debit ? element?.debit : "-",
            credit: element?.amount ? element?.amount : "-",
            balance: element?.runningBalance
              ? `${element?.currency?.code} ${element?.runningBalance}`
              : "-",
          });
        });

        objDetail?.charges?.forEach((element) => {
          tempChargesArray.push({
            key: element?.id,
            id: element?.id,
            name: element?.name ? BOM.SubstringFormat(element?.name, 20) : "-",
            penalty: element?.penalty ? "Penalty" : "Fee",
            paymentDueAt: element?.chargeTimeType?.value
              ? element?.chargeTimeType?.value
              : "-",
            dueAsOf: element?.dueDate
              ? BOM.DateTime(element?.dueDate, "only-date")
              : "-",
            repeatsOn: element?.feeOnMonthDay
              ? BOM.DateTimeWithoutYear(element?.feeOnMonthDay, "only-date")
              : "-",
            calculationType: element?.chargeCalculationType?.value
              ? element?.chargeCalculationType?.value
              : "-",
            due: element?.currency?.code
              ? `${element?.currency?.code} ${element?.amountOrPercentage}`
              : "-",
            paid: element?.currency?.code
              ? `${element?.currency?.code} ${element?.amountPaid}`
              : "-",
            waived: element?.currency?.code
              ? `${element?.currency?.code} ${element?.amountWaived}`
              : "-",
            outstanding: element?.currency?.code
              ? `${element?.currency?.code} ${element?.amountOutstanding}`
              : "-",
            status: handleFlgStatus(
              element?.isActive ? "active" : "closed",
              {},
              true
            ),
          });
        });

        setChargesList(tempChargesArray);
        setTransactionsList(tempTransactionsArray);

        /**
         * ON CLICK ACTION MENU
         */
        setMenuProps({
          items: handleGroupSavingsDetailActionButtons(objDetail),
          onClick: (e) => {
            const item = handleGroupSavingsDetailActionButtons(objDetail).find(
              (element) => element.key === e.key
            );
            if (item) {
              switch (item?.label.toLowerCase()) {
                case "calculate interest":
                  return calculateInterest();
                case "post interest":
                  return postInterest();

                default:
                  //ROUTE REDIRECTING ACTIONS
                  return navigate(item.route, {
                    state: {
                      ...state,
                      accountNo: objDetail.accountNo,
                      actionLabel: item.label,
                    },
                  });
              }
            }
          },
        });
        /**
         * ACTIVATE DELETE RIGHT BUTTON ACTION
         */
        if (
          objDetail?.status?.value.toLowerCase() ===
            accountStatus.submittedAndPending &&
          BOM.HasPermission("DELETE_SAVINGSACCOUNT")
        ) {
          rightAction(cnt.RIGHT_DELETE_BTN);
        }

        /**
         * STOP LOADER
         */
        setIsLoading(false);
      }
    });
  };

  const getNotes = () => {
    setIsLoading(true);

    const url = `${apiConfig.Savings}/${state.id}/notes`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        let tempMemoArray = [];

        objDetail?.forEach((element) => {
          tempMemoArray.push({
            key: element?.id,
            memoId: element?.id,
            createdBy: element?.createdByUsername
              ? element?.createdByUsername
              : "-",

            memo: element?.note ? element?.note : "-",
            createdOn: element?.createdOn ? element?.createdOn : "-",
          });
        });
        setMemoList(tempMemoArray);

        setIsLoading(false);
      }
    });
  };

  const onTabChange = (key) => {
    setActiveTabKey(key);
  };

  const handleOnDelete = () => {
    let action = "Delete Account  ";
    let accountNo = accountDetails.accountNo;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + accountNo,
      "Yes",
      "No",

      function () {
        setIsLoading(true);
        const url = `${apiConfig.SavingsAccounts}/${state.id}`;
        let body = {
          session,
          method: "DELETE",
          session,
        };
        BOM.FetchReqAction(body, url, (err, res) => {
          if (err) {
            BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
            //STOP LOAD
            setIsLoading(false);
          } else {
            BOM.AlertMsg(cnt.SUCCESS, labelConfig.deleteSavingsGrpMsg);
            navigate("/detail-group", {
              state: { id: state.mainGrpId },
            });
            //STOP LOAD
            setIsLoading(false);
          }
        });
      },

      function () {
        // No button
      }
    );
  };

  function onCancel() {
    navigate("/detail-group", { state: { id: state.mainGrpId } });
  }

  function postInterest() {
    setIsLoading(true);
    const params = {
      command: "postInterest",
    };
    const url = `${apiConfig.SavingsAccounts}/${state.id}`;

    let body = {
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.postIntrstSavingsGrpMsg);
        //STOP LOAD
        setIsLoading(false);
      }
    });
  }

  function calculateInterest() {
    setIsLoading(true);
    const params = {
      command: "calculateInterest",
    };
    const url = `${apiConfig.SavingsAccounts}/${state.id}`;

    let body = {
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.calculateIntrstSavingsGrpMsg);
        //STOP LOAD
        setIsLoading(false);
      }
    });
  }

  const contentListNoTitle = {
    transactions: (
      <Transactions
        transactionsList={transactionsList}
        userData={userData}
        state={state}
      />
    ),
    charges: (
      <Charges
        chargesList={chargesList}
        setChargesList={setChargesList}
        state={state}
        userData={userData}
        refreshDetail={getDetailById}
        refreshNote={getNotes}
        objDetail={accountDetails}
      />
    ),
    memo: <Memo memoList={memoList} />,
  };

  return (
    <MainLayout isEnableRightSidebar={true} onDelete={handleOnDelete}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.groupSavingsDetail}
        pageItems={staticConfig.grpSavingsDetailBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
          title={
            <Row
              style={{
                alignContent: "center",
                width: "8%",
              }}
            >
              <Button
                icon={<LeftOutlined />}
                type="text"
                style={{
                  marginTop: "auto",
                  marginBottom: "auto",
                }}
                onClick={onCancel}
              >
                <Text
                  style={{
                    marginTop: "auto",
                    marginBottom: "auto",
                    fontSize: 15,
                  }}
                >
                  Back
                </Text>
              </Button>
            </Row>
          }
        >
          <Form
            form={useForm}
            layout="vertical"
            style={{ paddingTop: 20, marginBottom: 50 }}
          >
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.generalInfo}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10 }} />
            <Row>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Dropdown.Button
                  menu={menuProps}
                  icon={<SettingOutlined />}
                  placement="topLeft"
                >
                  Actions
                </Dropdown.Button>
              </Col>

              <Col span={12} style={{ padding: "0px 8px" }}>
                <AccountFacility
                  accountName={accountDetails?.savingsProductName}
                  productName={accountDetails?.savingsProductName}
                  accountNo={accountDetails?.accountNo}
                  status={accountDetails?.status}
                />
              </Col>
            </Row>

            <Row style={{ marginBottom: 30 }}>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Card
                  bordered={true}
                  bodyStyle={{
                    paddingTop: 17,
                    paddingBottom: 17,
                    paddingLeft: 24,
                  }}
                  hoverable={true}
                  style={{ marginBottom: 16 }}
                >
                  <AmountFormat
                    labelName={labelConfig.currentBalance}
                    currency={accountDetails?.currency?.code}
                    amount={accountDetails?.summary?.availableBalance}
                    precision={accountDetails?.summary?.currency?.decimalPlaces}
                  />
                </Card>
              </Col>

              <Col span={12} style={{ padding: "0px 8px" }}>
                <Card
                  bordered={true}
                  bodyStyle={{
                    paddingTop: 17,
                    paddingBottom: 17,
                    paddingLeft: 24,
                  }}
                  hoverable={true}
                  style={{ marginBottom: 16 }}
                >
                  <AmountFormat
                    labelName={labelConfig.availableBalance}
                    currency={accountDetails?.currency?.code}
                    amount={accountDetails?.summary?.availableBalance}
                    precision={accountDetails?.summary?.currency?.decimalPlaces}
                  />
                </Card>
              </Col>
            </Row>

            <Row>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <SavingsDetails accountDetails={accountDetails} />
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <PerformanceHistory accountDetails={accountDetails} />
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <InterestDetails accountDetails={accountDetails} />
              </Col>
            </Row>
          </Form>
        </Card>
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            width: "100%",
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
            marginTop: 24,
          }}
          tabList={tabList}
          activeTabKey={activeTabKey}
          onTabChange={onTabChange}
          tabProps={{
            size: "middle",
          }}
        >
          {contentListNoTitle[activeTabKey]}
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
const mapDispatchToProps = { rightAction };

export default connect(mapStateToProps, mapDispatchToProps)(DetailGroupSavings);

function SavingsDetails(props) {
  const { accountDetails } = props;

  return (
    <Collapse
      style={{
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
        marginBottom: 25,
      }}
    >
      <Panel
        header={
          <Title level={5} style={{ margin: 0 }}>
            {labelConfig.accountInfo}
          </Title>
        }
        key="1"
      >
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 15,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomLeftRadius: 0,
              }}
            >
              <Text strong>{labelConfig.activationDate}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {BOM.FormatArrayDate(accountDetails?.timeline?.activatedOnDate)}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.bban}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.externalId
                  ? accountDetails?.externalId
                  : " - "}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.depositIban}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.externalId
                  ? accountDetails?.externalId
                  : " - "}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.externalID}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.externalId
                  ? accountDetails?.externalId
                  : " - "}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.nominalInterestRate}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.nominalAnnualInterestRate ||
                accountDetails?.nominalAnnualInterestRate === 0
                  ? `${accountDetails?.nominalAnnualInterestRate}%`
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.currency}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.currency?.name
                  ? `${accountDetails?.currency?.name}(${accountDetails?.currency?.code})`
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.accountOfficer}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.fieldOfficerName
                  ? accountDetails?.fieldOfficerName
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderTopLeftRadius: 0,
              }}
            >
              <Text strong>{labelConfig.status}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.currency?.name
                  ? `${accountDetails?.status?.value}`
                  : "0"}
              </Text>
            </Col>
          </Row>
        </div>
      </Panel>
    </Collapse>
  );
}

function PerformanceHistory(props) {
  const { accountDetails } = props;

  return (
    <Collapse
      style={{
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
        marginBottom: 25,
      }}
    >
      <Panel
        header={
          <Title level={5} style={{ margin: 0 }}>
            {labelConfig.performanceHistory}
          </Title>
        }
        key="1"
      >
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 15,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomLeftRadius: 0,
              }}
            >
              <Text strong>{labelConfig.interestEarned}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.currency?.code
                  ? accountDetails?.currency?.code
                  : "-"}{" "}
                {accountDetails?.summary?.totalInterestEarned ||
                accountDetails?.summary?.totalInterestEarned === 0
                  ? accountDetails?.summary?.totalInterestEarned
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 15,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderTopLeftRadius: 0,
              }}
            >
              <Text strong>{labelConfig.totalDeposits}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                <Text style={{ color: "#b8b8b8" }}>
                  {accountDetails?.currency?.code
                    ? accountDetails?.currency?.code
                    : "-"}{" "}
                  {accountDetails?.summary?.totalDeposits ||
                  accountDetails?.summary?.totalDeposits === 0
                    ? accountDetails?.summary?.totalDeposits
                    : "-"}
                </Text>
              </Text>
            </Col>
          </Row>
        </div>
      </Panel>
    </Collapse>
  );
}

function InterestDetails(props) {
  const { accountDetails } = props;

  return (
    <Collapse
      style={{
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
        marginBottom: 25,
      }}
    >
      <Panel
        header={
          <Title level={5} style={{ margin: 0 }}>
            {labelConfig.financialInfo}
          </Title>
        }
        key="1"
      >
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 15,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomLeftRadius: 0,
              }}
            >
              <Text strong>{labelConfig.lienBlockedAmount}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.currency?.code
                  ? accountDetails?.currency?.code
                  : "-"}{" "}
                {accountDetails?.summary?.totalAnnualFees ||
                accountDetails?.summary?.totalAnnualFees === 0
                  ? accountDetails?.summary?.totalAnnualFees
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.earnedIntrstNotPosted}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.currency?.code
                  ? accountDetails?.currency?.code
                  : "-"}{" "}
                {accountDetails?.summary?.totalInterestEarned ||
                accountDetails?.summary?.totalInterestEarned === 0
                  ? accountDetails?.summary?.totalInterestEarned
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.nominalInterestRate}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.nominalAnnualInterestRate ||
                accountDetails?.nominalAnnualInterestRate === 0
                  ? `${accountDetails?.nominalAnnualInterestRate}%`
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.interestCompoundingPeriod}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.interestCompoundingPeriodType
                  ? accountDetails?.interestCompoundingPeriodType?.value
                  : " - "}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.interestPostingPeriod}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.interestPostingPeriodType
                  ? accountDetails?.interestPostingPeriodType?.value
                  : " - "}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.interestCalculatedUsing}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.interestCalculationType
                  ? accountDetails?.interestCalculationType?.value
                  : " - "}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.daysInYear}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.interestCalculationDaysInYearType
                  ? accountDetails?.interestCalculationDaysInYearType?.value
                  : " - "}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.lastActiveTransactionDate}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.lastActiveTransactionDate
                  ? BOM.FormatArrayDate(
                      accountDetails?.lastActiveTransactionDate
                    )
                  : " - "}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 15,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderTopLeftRadius: 0,
              }}
            >
              <Text strong>{labelConfig.annualFee}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.annualFee
                  ? `${accountDetails?.annualFee?.currency?.code}
                                    ${accountDetails?.annualFee?.amount} 
                                    on ${BOM.DateTimeWithoutYear(
                                      accountDetails?.annualFee?.feeOnMonthDay,
                                      "only-date"
                                    )}`
                  : " - "}
              </Text>
            </Col>
          </Row>
        </div>
      </Panel>
    </Collapse>
  );
}
